module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/join-bg-aba0d8ccbacde058c38e2f6dbd1005c3.jpg";